<script>
	import { fly } from 'svelte/transition'

	export let articles = []

	let shown = 6
</script>

<style>
	.btn {
		background-color: #29b767;
		margin: 24px 0 0;
		padding: 15px 2em;
		width: 100%;
		border-radius: 3px;
	}
</style>

{#if articles.length}
	<h3>News</h3>
	<div class="grid-two">
		{#each articles.slice(0, shown) as article (article.url)}
			<div class="grid-item news-grid-item" in:fly={{ x: -15 }}>
				<div>
					<span>{article.date}</span>
					<em>{article.cat}</em>
				</div>
				<h5>{article.title}</h5>
				<a href={article.url}>
					<span>
						Read More
						<svg width="35" height="20">
							<path
								fill-rule="evenodd"
								fill="#28B768"
								d="M35 10.5c0 .3-.2.7-.4 1l-7.7 8c-.6.5-1.6.7-2.2.2-.5-.5-.5-1.6
								0-2.1l5.5-5.7H1.5C.7 12 0 11.3 0 10.5 0 9.7.7 9 1.5
								9h28.7l-5.4-5.7c-.5-.5-.6-1.6 0-2.1.5-.5 1.6-.4 2 .1l7.8
								8.1c.3.3.4.6.4 1z" />
						</svg>
					</span>
				</a>
			</div>
		{/each}
	</div>
	{#if shown < articles.length}
		<button class="btn" on:click={() => (shown = shown + 6)}>Show More</button>
	{/if}
{/if}
